(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('FileFolderService', FileFolderService)

    /** @ngInject */
    function FileFolderService(HttpService) {
        const FileFolderService = {
            getFolderContent: getFolderContent
        }

        return FileFolderService;

        function getFolderContent(params, personId, folderId, folderUrl) {
            let url = `/${personId}`;

            if (folderId)
                url = url.concat(`/${folderId}`);

            if (folderUrl)
                url = url.concat(`?folderUrl=${folderUrl}`);

            return HttpService.get(`/folders/parameters${url}`, {
                params
            });
        }
    }
}());